import dayjs from "dayjs";
import React from "react";
import { connect } from "react-redux";
import { compose } from "recompose";
import { ReceivedOrderPageJson } from "../../DynamicFormsJson/MastersJSON/receivedOrderPage";
import {
    getApprovalPendingList,
} from "../../Slice/OrderHeaderList.slice";
import DynamicMainScreen from "../../components/dynamicscreens/DynamicMainScreen";
import { withRouter } from "../../components/withRouter";
import endpoint from "../../config/endpoints";
import {
    approveOrder,
    noInternetMsg,
    orderApprovedMsg,
    serverMsg
} from "../../config/messageconstant";
import { ReceivedOrderColumns } from "../../tableColumns/table-columns";
import { apiGet } from "../../utils/api_service";
import { showLoador, showNotification } from "../Landing/Landing.slice";

class ReceivedOrderPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            fromDate: "",
            toDate: "",
        };
    }
    async componentDidMount() {
        const { showNotification } = this.props;

        if (navigator.onLine) {
            await this.getData();

        } else {
            showNotification({ msg: noInternetMsg, severity: "error" });
        }

    }
    getData = async () => {
        const { getApprovalPendingList, showLoador, showNotification } = this.props;
        if (navigator.onLine) {

            localStorage.removeItem("dealerTypeId");

            const formData = localStorage.getItem("formData");
            if (formData == null) {
                let todaysDate = dayjs().format("DD-MM-YYYY");
                showLoador({ loador: true });
                await getApprovalPendingList({
                    fromDate: todaysDate,
                    toDate: todaysDate
                }).then(({ success }) => {
                    if (!success) {
                        showNotification({ msg: serverMsg, severity: "error" });
                    }
                });
                showLoador({ loador: false });

            }
        } else {
            showNotification({ msg: noInternetMsg, severity: "error" });
        }
    };

    rowAccept = async (row) => {
        const { showLoador, showNotification } = this.props;
        const {
            fromDate,
            toDate,
        } = this.state;

        const dataObj = {
            fromDate: fromDate ? fromDate : dayjs().format("DD-MM-YYYY"),
            toDate: toDate ? toDate : dayjs().format("DD-MM-YYYY"),
        }

        swal({
            text: approveOrder,
            icon: "warning",
            buttons: true,
            dangerMode: true,
        }).then(async (willDelete) => {
            if (willDelete) {
                if (navigator.onLine) {
                    {
                        showLoador({ loador: true });
                        await apiGet({
                            url:
                                endpoint.stockStakeholderOrderHeader +
                                "/update-status?ids=" +
                                row.id +
                                "&status=1&remark=" +
                                row.remark,
                        }).then(({ success }) => {
                            if (success) {
                                showNotification({
                                    msg: orderApprovedMsg,
                                });
                                this.onSearchList(dataObj);
                            } else {
                                showNotification({
                                    msg: serverMsg,
                                    severity: "error",
                                });
                                showLoador({ loador: false });
                            }
                        });
                        showLoador({ loador: false });

                    }
                } else {
                    showNotification({ msg: noInternetMsg, severity: "error" });
                }
            }
        });
    }


    onSearchList = async (data) => {
        const {
            getApprovalPendingList,
            showLoador,
            showNotification,
        } = this.props;

        this.setState({
            fromDate: data.fromDate,
            toDate: data.toDate,
        });
        if (navigator.onLine) {
            showLoador({ loador: true });
            await getApprovalPendingList({
                fromDate: data.fromDate || dayjs().format("DD-MM-YYYY"),
                toDate: data.toDate || dayjs().format("DD-MM-YYYY"),
            }).then(({ success }) => {
                if (!success) {
                    showNotification({ msg: serverMsg, severity: "error" });
                }
            });
            showLoador({ loador: false });

        } else {
            showNotification({ msg: noInternetMsg, severity: "error" });
        }
    };

    rowEdit = (data) => {
        localStorage.setItem("dealerTypeId", data.dealerTypeId)
        this.props.navigate(ReceivedOrderPageJson.formPath + "/" + data.id);
    }

    onClearDataMethod = () => {
        this.getData();
    }

    onChangeStatusStatic = () => {
    }

    render() {
        const { orderList } = this.props;

        return (
            <>
                <DynamicMainScreen
                    deleteMsgAuto={true}
                    showViewButtonInTable={true}
                    showDeleteIcon={false}
                    onClearDataMethod={this.onClearDataMethod}
                    onClearDataMethodFlag={true}
                    searchList={ReceivedOrderPageJson.searchList}
                    onSearchData={this.onSearchList}
                    formPathView={ReceivedOrderPageJson.formPathView}
                    formPath={ReceivedOrderPageJson.formPath}
                    screenTitle={ReceivedOrderPageJson.screenTitle}
                    fieldMeta={ReceivedOrderPageJson.fieldMeta}
                    showPdfDownload={false}
                    showExcelDownload={false}
                    isActiveURL={ReceivedOrderPageJson.isActiveURL}
                    showAddButton={ReceivedOrderPageJson.showAddButton}
                    tableColumns={ReceivedOrderColumns}
                    tableData={orderList?.orderList}
                    apiBaseURL={ReceivedOrderPageJson.apiBaseURL}
                    getTableDataById={true}
                    callApi={false}
                    showSearchBox={true}
                    showPdf={false}
                    showPegination={false}
                    showAcceptIcon={true}
                    rowAccept={this.rowAccept}
                    onChangeStatusStatic={this.onChangeStatusStatic}
                    chipCompoColor={true}
                    getTableData={this.getData}
                    tableColumnsToFilter={ReceivedOrderPageJson.tableColumnsToFilter}
                    editAuto={false}
                    rowEdit={this.rowEdit}
                    chipColorSuccess={true}
                />
            </>
        );
    }
}
const mapStateToProps = (state) => ({
    orderList: state.orderHeaderList,
});

const mapDispatchToProps = {
    showNotification,
    showLoador,
    getApprovalPendingList,
};

export default compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps)
)(ReceivedOrderPage);
